import WhatIsThisModal from "./WhatIsThisModal";

export default WhatIsThisModal;
